import { debounce } from './utils'
import SGMap from './SGMap'
import { SWITCH_BAR_CLICKED } from './constants'

const isContactAreaLocations = ($) => $('[data-node-type="contact_area_locations"]').get(0)

// top LIST|MAP switch
const setupSwitchButtons = ($) =>
  $('[data-node-switch-bar]').on(SWITCH_BAR_CLICKED, (_, d) => {
    if (d.type == 'map') {
      showMapView($)
    }
  })
// $('[data-switch-button]').on('click', function(e) {
//   e.preventDefault()
//   e.stopPropagation()

//   if ($(this).hasClass('active')) {
//     return
//   }

//   $('[data-switch-button]').toggleClass('active')

//   const v = $($(this).data('switch-button'))
//   v.toggleClass('hidden')

//   $('.node-recruiting-map').attr('data-view-type', $(this).data('switch-view-type'))

//   showMapView($)
//   // pushState('active_view=map')
// })

let mapInitialized = false
let areas = {}

const showMapView = ($) => {
  if (mapInitialized) {
    return
  }
  mapInitialized = true
  const locations = $('[data-locations]').data('locations')

  const sgMap = new SGMap([], 'contacts', $('[data-contacts-map]').get(0), $('[data-info-win-template]').html())
  const areas = $('[data-contact-areas]').data('contact-areas')

  sgMap.setAreas(areas)

  $('body').on('SGMap.filterByAreaID', function(e, areaID) {
    showModal('[data-modal-contacts]')
    areaSearch($, areaID)
  })
}

const closeModal = (e) => {
  setTimeout(function() {
    $('body')
      .removeAttr('scroll')
      .css({ overflow: 'auto' })
    e.remove()
  }, 500)

  $('.contacts-modal-background, .contacts-modal-pane').addClass('enter')
}

const showModal = (sel) => {
  $('.contacts-modal').remove()
  // template
  const mhtml = $(sel).html()
  const modal = $(mhtml).appendTo('body')

  const bg = modal.find('.contacts-modal-background')
  // background close
  bg.on('click', () => closeModal(modal))
  // close btn
  $('[data-dismiss="modal"]', modal).on('click', () => closeModal(modal))

  // dont scroll on body
  $('body')
    .attr('scroll', 'no')
    .css({ overflow: 'hidden' })

  // animation
  setTimeout(function() {
    $('.enter', modal).removeClass('enter')
  }, 1)

  return modal
}

const areaSearch = ($, contactAreaID) => {
  $('.contacts-modal .contacts-content').addClass('loading')

  const url = $('[data-contact-search-url]').data('contact-search-url')

  const q = `contact_area_id=${contactAreaID}`

  $.get(`${url}?${q}`, (res) => {
    $('.contacts-modal .contacts-content').removeClass('loading')
    const $res = $(res)
    $('.contacts-modal .node-contact-list-list').html(
      $res.find('.node-contact-list-list .node-contact-list-items').html()
    )
    pushState(q)
  })
}

const countrySearch = ($, cc) => {
  $('.contacts-modal .contacts-content').addClass('loading')

  const url = $('[data-contact-search-url]').data('contact-search-url')

  const q = `q[country_code_eq]=${cc}`

  $.get(`${url}?${q}`, (res) => {
    $('.contacts-modal .contacts-content').removeClass('loading')
    const $res = $(res)
    $('.contacts-modal .node-contact-list-list').html(
      $res.find('.node-contact-list-list .node-contact-list-items').html()
    )
    pushState(q)
  })
}

const setupCountryButtons = ($) => {
  $(document).on('click', '[data-contact-country-code]', function(e) {
    e.preventDefault()
    const cc = $(this).data('contact-country-code')
    showModal('[data-modal-contacts]')
    countrySearch($, cc)
  })
}

const pushState = (q) => {
  if ('pushState' in history) {
    const html = $('.node-contact-list-list .node-contact-list-items').html()

    history.pushState({ type: 'contact_list', q, html }, '' + document.title, `?${q}`)
  }
}

const setupPopstate = ($) => {
  window.onpopstate = function(event) {
    if (event.state && typeof event.state === 'object' && event.state.type === 'contact_list') {
      $('.node-contact-list-list .node-contact-list-items').html(event.state.html)
    }
  }
}

const setup = ($) => {
  if (!isContactAreaLocations($)) {
    return
  }
  setupSwitchButtons($)
  setupCountryButtons($)
  setupPopstate($)
}

export default setup



// WEBPACK FOOTER //
// app/javascript/sg/js/contact_area_locations.js